export default function Footer(){

    return(
    <div>
          <div class="container">
                <div class="m-4">
                      <p className="learn">Platform Developed By Nitin Singh! This is beta version and other courses will be updated soon!</p>
                      <h3 className="learn">Features:</h3>
                      <ol>
                            <li className="learn">Distraction Free Youtube Learning</li>
                            <li className="learn">3x page optimization speed</li>
                            <li className="learn">Lite Version</li>
                            <li className="learn">Focused Learning</li>
                      </ol>
                      <h3 className="learn">Future Goals:</h3>
                      <ol>
                            <li className="learn">User Base Personalization(Statefull)-will need your cookies </li>
                            <li className="learn">Dedicated Account for each user</li>
                            <li  className="learn" >Course Completion Tracking</li>
                            <li  className="learn">....many more ❤ (P.S: I am out of ideas if you have one, inform me 😊)</li>
                      </ol>
                </div>
    
          </div>
          {/* <center>Source Code: <a href="https://github.com/hotheadhacker/youtube-player" target="_BLANK">being-nitin/youtube-player</a></center> */}
    <footer className="footer mt-2 bg-danger">
           <h3  className="learn">Designed by 😄 <a href="https://unrivaled-meringue-82d9e8.netlify.app/">Nitin Singh</a></h3>
           <p className="footer-para">
           <a href="https://github.com/being-nitin"><i className="zmdi zmdi-github-alt">Github</i></a>
           <a href="https://twitter.com/NitinSi17842968" target="_BLANK"><i className="zmdi zmdi-twitter"></i>Twitter</a>
           <a href="https://www.instagram.com/being_nitin02/" target="_BLANK"><i className="zmdi zmdi-instagram">Instagram</i></a>
           <a href="https://unrivaled-meringue-82d9e8.netlify.app/" target="_BLANK"><i className="zmdi zmdi-account">Portfolio</i></a>
           <a href="mailto:singhnitin0207@gmail.com" target="_BLANK"><i className="zmdi zmdi-google">Mail</i></a>
           {/* <a href="https://blog.isalman.xyz" target="_BLANK"><i className="fas fa-blog fa-2x mx-2 blog"></i></a> */}
           </p>
          </footer></div>
    )
    }